import { ScriptingLanguage } from "@octopusdeploy/octopus-server-client";
import type { Language, TextFormat } from "~/components/CodeEditor/CodeEditor";
export function createHelmCommand(language: ScriptingLanguage | Language | TextFormat) {
    const lineBreak = language === ScriptingLanguage.Bash ? "\\" : "`";
    return `helm upgrade --install --atomic ${lineBreak}
--create-namespace --namespace octopus-permissions-controller-system ${lineBreak}
--reset-then-reuse-values ${lineBreak}
octopus-permissions-controller ${lineBreak}
oci://registry-1.docker.io/octopusdeploy/octopus-permissions-controller-chart`;
}
